import Service, {parseParams} from 'api';

export const list = (params = {}, config) => {
  const parsedParams = parseParams({
    sort: 'name',
    limit: 0,
    ...params,
  });

  return Service.get(`practice_areas?${parsedParams}`, config);
};

export const post = (data = {}, config = {}) => Service.post('practice_areas', data, config);
export const put = (id, data = {}, config = {}) => Service.put(`practice_areas/${id}`, data, config);
export const destroy = (id, config) => Service.delete(`practice_areas/${id}`, config);
